import type { User } from 'app/types/user';
import type { Listing } from 'app/types/listing';
import { canUseListingTags } from 'app/utils/helpers';
import { getI18nLanguage } from './language';

export function getListingCatalogLabels(
  listing: Pick<Listing, 'categoryPrimary' | 'listingsTags'>,
  featureFlags?: User['featureFlags'],
) {
  if (!canUseListingTags(featureFlags)) {
    const category = listing.categoryPrimary;
    return category ? [{ id: category.id, label: category.name[getI18nLanguage()] }] : [];
  }

  return listing.listingsTags?.map((tag) => ({ id: tag.tagId, label: tag.tagName })) ?? [];
}
